/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Empty_CtaInputs */

const en_us2_progress_empty_cta = /** @type {(inputs: Progress_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Train now`)
};

const pt_br2_progress_empty_cta = /** @type {(inputs: Progress_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinar agora`)
};

const es_419_progress_empty_cta = /** @type {(inputs: Progress_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenar ahora`)
};

const pt_pt2_progress_empty_cta = /** @type {(inputs: Progress_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinar agora`)
};

const fr_fr2_progress_empty_cta = /** @type {(inputs: Progress_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S'entraîner`)
};

const de_de2_progress_empty_cta = /** @type {(inputs: Progress_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt trainieren`)
};

const it_it2_progress_empty_cta = /** @type {(inputs: Progress_Empty_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenati ora`)
};

/**
* | output |
* | --- |
* | "Train now" |
*
* @param {Progress_Empty_CtaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_empty_cta = /** @type {((inputs?: Progress_Empty_CtaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Empty_CtaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_empty_cta(inputs)
	if (locale === "es-419") return es_419_progress_empty_cta(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_empty_cta(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_empty_cta(inputs)
	if (locale === "de-DE") return de_de2_progress_empty_cta(inputs)
	if (locale === "it-IT") return it_it2_progress_empty_cta(inputs)
	return en_us2_progress_empty_cta(inputs)
});
export { progress_empty_cta as "progress.empty_cta" }